import { ia } from 'lib/helpers/utility';
import useModal from 'lib/hooks/useModal';

import Popover from 'components/shared/Popovers/Popover/Popover';
import useViewReceipt from 'components/shared/Receipt/lib/useViewReceipt';

import RefundAdminModal from './RefundAdminModal';

export const Actions = ({ data }) => {
  const [receiptOption, receiptModal] = useViewReceipt({ data });

  const {
    isOpen: isRefundModalOpen,
    openModal: openRefundModal,
    closeModal: closeRefundModal
  } = useModal();

  const isRefundable =
    ['completed', 'partially_refunded'].includes(data?.status?.toLowerCase()) && !data?.isPatient;

  const actionsOptions = [
    ...(receiptOption ? [receiptOption] : []),
    ...(isRefundable
      ? [
          {
            label: 'Refund',
            icon: 'money-send-mono',
            onClick: openRefundModal
          }
        ]
      : [])
  ];

  if (!ia(actionsOptions)) return null;

  return (
    <>
      <Popover
        className="flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        options={actionsOptions}
        isBorder={false}
      />
      {receiptModal}
      <RefundAdminModal
        isOpen={!!isRefundModalOpen}
        onClose={closeRefundModal}
        transaction={data}
      />
    </>
  );
};

export default Actions;
